import { ProductsTabs } from 'src/products/layout/ProductsTabs';
import { useTabNavigationSetter } from 'src/common/components/AppLayout/AppNavigation/hooks/useTabNavigationSetter';
import { productNavigationAtom } from 'src/atoms/pages/pages';
import { Routes } from 'src/Routes.constants';
import { ProductSummary } from './ProductSummary';
import { SelectedProductContextProvider } from './SelectedProductContextProvider';
import { ProductsSummaryGraphs } from './Graphs/ProductsSummaryGraphs';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';
import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { useTranslation } from 'react-i18next';
import { PageWithGraphs } from 'src/common/components/Layouts/PageLayout/PageWithGraphs';
import { openProductGraphsContainer } from 'src/atoms/ui/graphs';

export const ProductSummaryPage = () => {
  useTabNavigationSetter({ tabsAtom: productNavigationAtom, routeToSet: Routes.productSummary });

  const dashboardEnabled = useHasFeatureFlag('AnalyticsModule');

  const { t } = useTranslation();
  return (
    <SelectedProductContextProvider>
      <PageWithGraphs
        graphs={dashboardEnabled && <ProductsSummaryGraphs />}
        slots={{
          graphsContainer: {
            openAtom: openProductGraphsContainer,
          },
        }}
      >
        <ProductsTabs>
          <TabPanelWithErrorHandling name={t('productSummary.productSummary')}>
            <ProductSummary />
          </TabPanelWithErrorHandling>
        </ProductsTabs>
      </PageWithGraphs>
    </SelectedProductContextProvider>
  );
};
